import 'babel-polyfill'
// You'll need to use async functions
import 'babel-core/register'
// A window.fetch JavaScript polyfill
import 'whatwg-fetch'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, hashHistory } from 'react-router'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import logger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
// import { persistStore, autoRehydrate } from 'redux-persist'
import Configs from './constants/Config'
import Auth from './utils/Auth'
import LocalStorage from './utils/LocalStorage'

import reducers from './reducers'
import mySaga from './sagas'

const historyMiddleware = routerMiddleware(hashHistory)
const sagaMiddleware = createSagaMiddleware()

const middlewares = [historyMiddleware, sagaMiddleware]
if (process.env.NODE_ENV !== 'production') {
  middlewares.push(logger)
}

const store = createStore(
  reducers,
  compose(
    applyMiddleware(...middlewares)
    // applyMiddleware(historyMiddleware),
    // applyMiddleware(sagaMiddleware),
    // applyMiddleware(logger),
    // autoRehydrate()
  )
)

// Begin periodically persisting the store
// localForage.config({
// 	driver: localForage.WEBSQL, // Force WebSQL; same as using setDriver()
// 	name: 'VES',
// 	version: 1.0,
// 	size: 4980736, // Size of database, in bytes. WebSQL-only for now.
// 	storeName: 'tempDB', // Should be alphanumeric, with underscores.
// 	description: 'some description'
// })
//persistStore(store, { storage: localForage })

sagaMiddleware.run(mySaga)

const history = syncHistoryWithStore(hashHistory, store)

function scrollToTop() {
  // window.scrollTo(0, 0)
}

const rootRoute = {
  childRoutes: [
    {
      path: '/',
      component: require('./containers/App'),
      // indexRoute: { onEnter: (nextState, replace) => Auth.loggedIn() ? replace('/glasses-list') : replace('/home') },
      indexRoute: {
        onEnter: (nextState, replace) => {
          if (process.env.NODE_ENV === 'production') {
            let lang = LocalStorage.getItem('lang')
            if (!lang) {
              let browserLang = navigator.language || 'en-US'
              if (browserLang.length >= 2) {
                browserLang = browserLang.substr(0, 2)
              }
              if (browserLang !== 'en' && browserLang !== 'ja' && browserLang !== 'fr') {
                browserLang = 'en'
              }
              lang = browserLang
            }
            if (lang === 'ja') {
              window.location.href = '/ja/index.html'
            } else if (lang === 'fr') {
              window.location.href = '/fr/index.html'
            } else {
              window.location.href = '/en/index.html'
            }
          } else {
            if (Auth.userId() === 26) {
              // Lens Direct
              replace('/glasses-list')
            } else {
              replace('/v2/glasses-list')
            }
          }
        }
      },
      childRoutes: [
        ...require('./routes/app'),
        require('./routes/admin'),
        require('./routes/core'),
        ...require('./routes/auth'),
        require('./routes/404'),
        require('./routes/500'),
        require('./routes/lockScreen'),
        require('./routes/fullscreen'),
        {
          path: '*',
          indexRoute: { onEnter: (nextState, replace) => replace('/404') }
        }
      ]
    }
  ]
}

render(
  <Provider store={store}>
    <Router onUpdate={scrollToTop} history={history} routes={rootRoute} />
  </Provider>,
  document.getElementById('app-container')
)



// WEBPACK FOOTER //
// ./client.js